<ng-template #templateRef>
    <form #editorForm="ngForm" name="editAccount" (ngSubmit)="save()" id="aclEditor">
        <h2 mat-dialog-title>{{Copy && Copy.Id ? 'Edit' : 'New'}} Permisson</h2>
        <mat-dialog-content *ngIf="Copy">
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field>
                      <mat-label>Description</mat-label>
                        <textarea matInput name="description" [(ngModel)]="Copy.Description"
                                  required></textarea>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{Copy.PrincipalId === 'API' ? 'Model Name' : 'Permission Name'}}</mat-label>
                        <textarea matInput name="id" [(ngModel)]="Copy.PrincipalType"
                                  required></textarea>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{Copy.PrincipalId === 'API' ? 'READ/WRITE/METHODNAME/WILDCARD(*)' : 'core.users, core.projects, ...'}}</mat-label>
                        <textarea matInput name="access" [(ngModel)]="Copy.AccessType"
                                  required></textarea>
                    </mat-form-field>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="fill-remaining-space"></div>
            <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
            <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
        </mat-dialog-actions>
    </form>
</ng-template>

